<template>
  <div class="carousel-container">
    <!-- Swiper 容器 -->
    <div class="swiper">
      <div class="swiper-wrapper">
        <!-- 轮播项 -->
        <div class="swiper-slide" v-for="(item, index) in items" :key="index">
          <div class="my-swiper">
            <div class="container">
              <div class="card-container" @click="gotoBlogDetail">
                <div class="card-image">
                  <img :src="item.image" :alt="item.title" class="img-fluid">
                </div>
                <div class="card-content d-flex flex-column justify-content-between">
                  <div>
                    <div class="banner-title"><slot name="title"></slot></div>
                    <div class="date">29 November 2024</div>
                  </div>
                  
                  <div class="more d-flex justify-content-end align-items-center">
                    <div class="mr-2">閱讀更多</div>
                    <div><img src="@/assets/uupay/icon/svg/arrow_right.svg" alt="" class="img-fluid"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <!-- 分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css';

export default {
  name: 'BlogBanner',
  props: {
    items: {
      type: Array,
      required: true,
    },
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mySwiper: null
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.mySwiper = new Swiper('.swiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        // 循环模式
        loop: false,
        // 单页轮播
        slidesPerView: 1,
        spaceBetween: 0,
        // 分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          // renderBullet: function (index, className) {
          //   return '<span class="' + className + '"></span>';
          // },
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let activeBar = '<div class="swiper-pagination-bullet swiper-pagination-bullet-active" style="margin-right: 0.5rem;"><div class="swiper-pagination-bullet-active-bar"></div></div>'
            let inactive = '<div class="swiper-pagination-bullet" style="margin-right: 0.5rem;"></div>'
            if (current == 1) {
              return activeBar + inactive + inactive
            } else if (current == 2) {
              activeBar = '<div class="swiper-pagination-bullet swiper-pagination-bullet-active d-flex justify-content-center" style="margin-right: 0.5rem;"><div class="swiper-pagination-bullet-active-bar"></div></div>'
              return inactive + activeBar + inactive
            } else if (current == 3) {
              activeBar = '<div class="swiper-pagination-bullet swiper-pagination-bullet-active d-flex justify-content-end" style="margin-right: 0.5rem;"><div class="swiper-pagination-bullet-active-bar"></div></div>'
              return inactive + inactive + activeBar
            }
            
          }
        },
        // 导航按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 效果
        effect: 'slide',
        on: {
          slideChange: function () {
            // console.log('slideChange:', this.activeIndex);
            // this.pagination.render(this.activeIndex, 'swiper-pagination-bullet-active')
          },
          paginationRender: function(a){
            console.log('paginationRender:', a);
          },
        },
      })
    },
    gotoBlogDetail() {
      this.$router.push(this.link)
    }
  },
  beforeDestroy() {
    // 组件销毁时销毁Swiper实例
    if (this.mySwiper) {
      this.mySwiper.destroy(true, true)
    }
  }
}
</script>

<style scoped>
.carousel-container {
  width: 100%;
  height: 520px; /* 根据设计调整高度 */
  position: relative;
  /*overflow: hidden;*/
  margin: 3rem 0;
  padding-top: 30px;
}

.swiper {
  width: 100%;
  height: 100%;
  --swiper-theme-color: #9a307a;
  /*--swiper-pagination-bullet-inactive-color: #d9d9d9;*/
}

.my-swiper {
  width: 100%;
  height: 100%;
}

.card-container {
  display: flex;
  border-radius: 10px;
  /*box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);*/
  overflow: hidden;
  height: 420px; /* 固定高度 */
  background-color: #f3f3f5;
  margin: 0 1rem;
  cursor: pointer;
}

.card-image {
  flex: 0 0 60%;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card-image:hover img {
  transform: scale(1.05);
}

.card-content {
  flex: 1;
  padding: 3rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
}

.card-content .banner-title {
  font-size: 40px;
  margin-bottom: 15px;
  color: #21042e;
}
.card-content .date {
  color: #bc68a4;
  font-size: 16px;
}
.card-content .more {
  color: #9a307a;
  font-size: 20px;
  font-weight: 500;
  line-height: 100%;
  height: 28px;
  cursor: pointer;
}

.card-content p {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

/deep/ .swiper-pagination-custom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10px;
}
/* Swiper 自定义样式 */
/*.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: #ccc;
  opacity: 1;
}

.swiper-pagination-bullet-active {
  background: #333;

}*/

/* 自定义分页器样式 */
.swiper-pagination /deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 5px;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active-bar {
  width: 20px;
  height: 10px;
  border-radius: 5px;
  background-color: #9a307a;
  position: relative;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active {
  width: 30px;
  height: 10px;
  border-radius: 5px;
  background-color: #ccc;
  position: relative;
}
/*.swiper-pagination /deep/ .swiper-pagination-bullet-active::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  border-radius: 0 5px 5px 0;
  /*transform: translateY(-50%);
  width: 10px;
  height: 8px; 
  background-color: #e0e0e0; 
  z-index: 1; 
}*/

.swiper-button-prev,
.swiper-button-next {
  color: #333;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 20px;
}

@media (max-width: 768px) {
  .card-container {
    flex-direction: column;
    height: auto;
  }
  
  .card-image {
    flex: 0 0 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BlogBanner.vue